module.exports = __webpack_public_path__ + "static/roue-du-temps.b725a5f8.png";